import { render, staticRenderFns } from "./IconStore.vue?vue&type=template&id=3e6f4997&"
import script from "./IconStore.vue?vue&type=script&lang=js&"
export * from "./IconStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports